/* =====================================================================
   juizs-sticky-buybar.js — OD-015
   ---------------------------------------------------------------------
   Toont de meelopende koopbalk zodra de echte buy-box uit beeld is.
   De balk heeft geen eigen koop-logica: hij klikt `[data-jph-submit]`
   aan, zodat variant, verkoopplan, aantal en add-ons uit de buy-box
   automatisch meegaan en de AJAX-laag uit juizs-cart.js het overneemt.

   Golf 6a (01-10):
   · Onder 900px kijkt de balk naar de échte knop: zichtbaar zodra die
     boven uit beeld (of onder de vaste header) is, weg zodra hij terug is.
     Boven 900px ongewijzigd: de hele product-hero.
   · Spiegelt ook de variant (2+ varianten) en de gekozen koopvorm.
   · <body> krijgt ruimte onderaan zolang de balk zichtbaar is (alle breedtes,
     sinds 01-10 ook desktop), zodat de footer nooit bedekt raakt.
   · Neemt disabled + tekst van de echte knop over (uitverkocht).
   ===================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-juizs-sticky-bar]');
  if (!bar) return;

  var submit = document.querySelector('[data-jph-submit]');
  var hero = document.querySelector('.juizs-jph-section');
  var priceSource = document.querySelector('[data-jph-price-main]');
  var priceTarget = bar.querySelector('[data-juizs-sbb-price]');
  var variantTarget = bar.querySelector('[data-juizs-sbb-variant]');
  var planTarget = bar.querySelector('[data-juizs-sbb-plan]');
  var addBtn = bar.querySelector('[data-juizs-sbb-add]');
  var addText = bar.querySelector('[data-juizs-sbb-cta-text]');

  if (!submit) return;

  var mq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  function isMobile() { return !!mq && mq.matches; }
  var visibleNow = false;

  /* ---- Zichtbaarheid ---- */
  function setVisible(visible) {
    visibleNow = visible;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) {
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('inert', '');
    }
    // Ruimte onder de pagina zolang de balk er staat (CSS: body.juizs-sbb-open),
    // op alle breedtes: anders bedekt hij onderaan de footer
    if (visible) {
      document.documentElement.style.setProperty('--juizs-sbb-h', bar.offsetHeight + 'px');
    }
    document.body.classList.toggle('juizs-sbb-open', visible);
  }

  if ('IntersectionObserver' in window) {
    var observer = null;
    var observed = null;
    var watch = function () {
      var mobile = isMobile();
      // 29-07: op desktop de héle product-hero, niet de knop. Anders komt de
      // balk al op zodra de knop net buiten beeld is terwijl je nog in de hero
      // zit. Golf 6a: op mobiel juist de knop zelf (briefing §3.2.6).
      var target = mobile ? submit : (hero || submit);
      if (observer) observer.disconnect();
      observed = target;
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== observed) return;
            if (!mobile) { setVisible(!entry.isIntersecting); return; }
            // Mobiel: alleen als de knop bóven het zichtbare deel zit (voorbij
            // gescrold), niet als hij nog onder de vouw ligt.
            var top = entry.rootBounds ? entry.rootBounds.top : 0;
            setVisible(!entry.isIntersecting && entry.boundingClientRect.top < top);
          });
        },
        mobile
          ? { rootMargin: '-64px 0px 0px 0px', threshold: 0 } // vaste header ±61px
          : { rootMargin: '0px 0px -40px 0px', threshold: 0 }
      );
      observer.observe(target);
    };
    watch();
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', watch);
      else if (mq.addListener) mq.addListener(watch);
    }
  } else {
    // Terugval: balk gewoon tonen zodra je voorbij de vouw scrolt.
    window.addEventListener('scroll', function () {
      setVisible(window.scrollY > 600);
    });
  }

  /* ---- Spiegelen: prijs, variant, koopvorm, knopstaat ---- */
  function syncPrice() {
    if (priceSource && priceTarget) priceTarget.textContent = priceSource.textContent.trim();
    if (variantTarget) {
      var checked = document.querySelector('[data-jph-variant] input[type="radio"]:checked');
      var name = checked && checked.closest('[data-jph-variant]').querySelector('.juizs-jph-variant-name');
      if (name) variantTarget.textContent = name.textContent.trim();
    }
    if (planTarget) {
      var tab = document.querySelector('.juizs-jph-tab.is-active');
      planTarget.textContent = tab ? tab.textContent.trim() : '';
      planTarget.hidden = !tab;
    }
  }
  function syncButton() {
    if (!addBtn) return;
    var src = submit.querySelector('.juizs-jph-cta-text');
    var label = src ? src.textContent.trim() : '';
    addBtn.disabled = submit.disabled;
    if (label && addText) addText.textContent = label;
    if (label) addBtn.setAttribute('aria-label', label + ' – ' + (addBtn.getAttribute('data-juizs-sbb-title') || ''));
  }

  if ('MutationObserver' in window) {
    if (priceSource) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
    new MutationObserver(syncButton).observe(submit, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
  document.addEventListener('juizs:variant-change', function () { syncPrice(); syncButton(); });
  syncPrice();
  syncButton();

  // Hoogte kan wijzigen (lettergrootte, draaien): ruimte onder de pagina bijwerken
  window.addEventListener('resize', function () {
    if (visibleNow) document.documentElement.style.setProperty('--juizs-sbb-h', bar.offsetHeight + 'px');
  });

  /* ---- Kopen ---- */
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      submit.click();
    });
  }
})();
